/** @jsxImportSource @emotion/react */
import { BasePage } from 'components';
import { ActivationStepKey } from 'modules/activation/ActivationConfig';
import ActivationFlow from 'modules/activation/ActivationFlow';
import { useState } from 'react';

type BusinessDetailsPageProps = {
  onComplete: () => void | Promise<void>;
  initialStepKey?: ActivationStepKey;
};

export default function BusinessDetailsPage({
  onComplete,
  initialStepKey = ActivationStepKey.LocationDetails,
}: BusinessDetailsPageProps): React.JSX.Element {
  const [activeStepKey, setActiveStepKey] =
    useState<ActivationStepKey>(initialStepKey);

  return (
    <BasePage title={null} variant="layout" fullWidth>
      <ActivationFlow
        activeStepKey={activeStepKey}
        onStepChange={setActiveStepKey}
        onComplete={onComplete}
      />
    </BasePage>
  );
}
